import { render, staticRenderFns } from "./risk-category-badge.vue?vue&type=template&id=3c251ba3&"
import script from "./risk-category-badge.vue?vue&type=script&lang=js&"
export * from "./risk-category-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports